export default __webpack_public_path__ + "static/media/footer-4.16e072e3.jpg";